import { chakra } from '@chakra-ui/react';
import { type ReactNode } from 'react';

const Root = chakra('div', {
  base: { display: 'flex', alignItems: 'center', gap: '3', width: 'full', minWidth: 0 },
});

const Line = chakra('span', {
  base: { flex: '1', height: '1px', bg: 'border.default', minWidth: 0 },
});

const Label = chakra('span', {
  base: {
    flexShrink: 0,
    fontFamily: 'body',
    fontSize: 'xs',
    fontWeight: 'medium',
    letterSpacing: 'wider',
    textTransform: 'uppercase',
    color: 'text.muted',
  },
});

export interface DividerProps {
  /** Optional centered label that breaks the rule (e.g. "or"). */
  children?: ReactNode;
}

/** A horizontal rule; with an optional centered label it becomes an "or" separator. */
export function Divider({ children }: DividerProps) {
  const labelled = children != null && children !== '';
  return (
    <Root role="separator" aria-orientation="horizontal">
      <Line />
      {labelled && <Label>{children}</Label>}
      {labelled && <Line />}
    </Root>
  );
}
